module.exports = __webpack_public_path__ + "img/55_54.96626dae.png";